(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    function initFinder() {
      var btns = document.querySelectorAll('.felis-finder__btn');
      var cards = document.querySelectorAll('.felis-card-wrap');
      if (!btns.length || !cards.length) return;

      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          btns.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var filter = btn.getAttribute('data-filter');

          cards.forEach(function(card) {
            var cardFilters = card.getAttribute('data-filter') || '';
            if (filter === 'all' || cardFilters.split(' ').indexOf(filter) !== -1) {
              card.classList.remove('felis-hidden');
            } else {
              card.classList.add('felis-hidden');
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFinder);
    } else {
      initFinder();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
